// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectable_IlVXr:focus {
  outline: none;
}

.popup_TmSBn {
  font-family: Inter, 'Open Sans', sans-serif;
  --rdp-font-family: Inter, 'Open Sans', sans-serif;
}

.tether-element .popup_TmSBn {
  -webkit-box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
          box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
  border: 1px solid #E0E0E0;
  max-height: none;
  max-height: initial;
}

.rangeType_sIg9E > .rw-widget-input {
  height : 32px;
  width : 152px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.rangeType_sIg9E .rw-input {
  color: #007AFF;
  font-size: 12px;
  font-weight: bold;
}

.rangeType_sIg9E .rw-widget-input, .rangeType_sIg9E .rw-widget-input:hover {
  background-color: #F2F2F2;
}

.predeterminedTz_XCBps, .dateTimeEditor_hffRS, .calendar_RHqpa {
  padding: 8px 16px;
}

.globe_WQgsC {
  margin-right : 8px;
  font-size: 16px;
}

.predeterminedTz_XCBps {
  border-bottom : 1px solid #E0E0E0;
}

.arrow_sjyrw {
  height: 32px;
  margin-left : 8px;
  margin-right : 8px;
}

.timeEditor_WyRKI {
  margin-left: 8px;
}

.controls_tqJVf {
  background-color: #F2F2F2;
  padding: 8px 16px;
}

.apply_WpbWk {
  margin-left: 8px;
}

.inputLabel_sdItN {
  font-size: 12px;
  color : #808080;
}

.popup_TmSBn .startDate_JA4Oo, .popup_TmSBn .startTime_VIHAg, .popup_TmSBn .endDate_KMunx, .popup_TmSBn .endTime_CCQsI {
  background: rgba(242, 242, 242, 0.2);
  font-size: 16px;
}

.popup_TmSBn .startDate_JA4Oo, .popup_TmSBn .endDate_KMunx {
  width : 120px;
  padding: 0px 8px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  height: 32px;
  border-radius: 3px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.popup_TmSBn .endTime_CCQsI .rw-widget-picker, .popup_TmSBn .startTime_VIHAg .rw-widget-picker {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-size: 16px;
  border: 1px solid rgba(0, 0, 0, 0.25);
  height : 32px;
  border-radius: 3px;
  width : 140px;
  color: var(--color-label2);
}

.popup_TmSBn .endTime_CCQsI.rw-state-focus .rw-widget-container, .popup_TmSBn .startTime_VIHAg.rw-state-focus .rw-widget-container {
  -webkit-box-shadow: none;
          box-shadow: none;
}

.popup_TmSBn .startDate_JA4Oo:focus, .popup_TmSBn .endDate_KMunx:focus,
.popup_TmSBn .endTime_CCQsI.rw-state-focus .rw-widget-container, .popup_TmSBn .startTime_VIHAg.rw-state-focus .rw-widget-container {
  border-color: #007AFF;
}

.popup_TmSBn .startTime_VIHAg .rw-input, .popup_TmSBn .endTime_CCQsI .rw-input {
  padding-right : 0px;
}

.popup_TmSBn .startDate_JA4Oo.error_sRSYV, .popup_TmSBn .endDate_KMunx.error_sRSYV {
  border-color: var(--color-danger500);
  background-color: #fff0f0;
}

.popup_TmSBn .startDate_JA4Oo.error_sRSYV:hover, .popup_TmSBn .endDate_KMunx.error_sRSYV:hover {
  border-color: var(--color-danger600);
}

.dateTimeRangePicker_QHpgm {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  border-radius: 4px;
  height: 40px;
}

.dateTimeRangePicker_QHpgm > .startDate_JA4Oo {
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding : 8px 8px 8px 16px;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}

.dateTimeRangePicker_QHpgm > .endDate_KMunx {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding : 8px 16px 8px 8px;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
}

.dateTimeRangePicker_QHpgm > .endDate_KMunx, .dateTimeRangePicker_QHpgm > .startDate_JA4Oo {
  border-color : rgba(0, 0, 0, 0.25);
}

.error_sRSYV input {
  border-color: var(--color-danger500);
  background-color: #fff0f0;
}

.error_sRSYV:hover input {
  border-color: var(--color-danger600);
}

.toggleButtonTrigger_HIN0Q { 
  height : 40px;
}

.dateTimeRangePicker_QHpgm > .endDate_KMunx:active, .dateTimeRangePicker_QHpgm > .startDate_JA4Oo:active {
  border-color : #007AFF;
}

.dateTimeRangePicker_QHpgm > .arrow_sjyrw {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-top: 1px solid rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  height: 100%;
  margin: 0;
  padding: 0;
}


/* day picker custom style */

.selectable_IlVXr > .DayPicker-wrapper:focus {
  outline: none;
}

.DayPicker-Day--start.DayPicker-Day--selected, .DayPicker-Day--end.DayPicker-Day--selected {
    color: white;
    background-color: #b4ccf8;
}

.DayPicker-Day--start.DayPicker-Day--selected {
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
}

.DayPicker-Day--end.DayPicker-Day--selected {
  border-top-right-radius: 24px;
  border-bottom-right-radius: 24px;
}

.DayPicker-Day--selected {
  background-color: #b4ccf8;
}

.DayPicker-Day:not( .DayPicker-Day--outside ):hover {
  background-color: #a4bce8;
}

.circleEnd_ouZc5 {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border-radius: 24px;
  background-color: #382CDD;
  height: 35px;
  width: 36px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  border: 2px solid #b4ccf8;
}

.DayPicker-Day:hover .circleEnd_ouZc5 {
  border-color: #a4bce8;
}

.circle_vXxNo {
  background-color: transparent;
  height: 35px;
  width: 36px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

/* DayPicker styles */

.DayPicker {
  display: inline-block;
  font-size: 12px;
}

.DayPicker-wrapper {
  position: relative;

  -webkit-box-orient: horizontal;

  -webkit-box-direction: normal;

      -ms-flex-direction: row;

          flex-direction: row;
  padding-bottom: 8px;

  -webkit-user-select: none;

    -moz-user-select: none;

      -ms-user-select: none;

          user-select: none;
}

.DayPicker-Months {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.DayPicker-Month {
  display: table;
  margin: 0 8px;
  margin-top: 8px;
  border-spacing: 0;
  border-collapse: collapse;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-left : 8px;
  margin-right : 8px;
}

.DayPicker-NavBar {
}

.DayPicker-NavButton {
  position: absolute;
  top: 8px;
  right: 12px;
  left: auto;

  display: inline-block;
  margin-top: 2px;
  width: 12px;
  height: 12px;
  background-position: center;
  background-size: 50%;
  background-repeat: no-repeat;
  color: #8B9898;
  cursor: pointer;
}

.DayPicker-NavButton:hover {
  opacity: 0.8;
}

.DayPicker-NavButton--prev {
  margin-right: 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.DayPicker-NavButton--next {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.DayPicker-NavButton--interactionDisabled {
  display: none;
}

.DayPicker-Caption {
  display: table-caption;
  margin-bottom: 4px;
  padding: 0 4px;
  text-align: left;
}

.DayPicker-Caption > div {
  font-weight: 500;
  font-size: 14px;
}

.DayPicker-Weekdays {
  display: table-header-group;
  margin-top: 8px;
}

.DayPicker-WeekdaysRow {
  display: table-row;
}

.DayPicker-Weekday {
  display: table-cell;
  padding: 4px;
  color: #8B9898;
  text-align: center;
  font-size: 12px;
}

.DayPicker-Weekday abbr[title] {
  border-bottom: none;
  -webkit-text-decoration: none;
  text-decoration: none;
}

.DayPicker-Body {
  display: table-row-group;
}

.DayPicker-Week {
  display: table-row;
}

.DayPicker-Day {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  border-radius: 0;
}

.DayPicker-WeekNumber {
  display: table-cell;
  padding: 4px;
  min-width: 8px;
  border-right: 1px solid #EAECEC;
  color: #8B9898;
  vertical-align: middle;
  text-align: right;
  font-size: 10px;
  cursor: pointer;
}

.DayPicker--interactionDisabled .DayPicker-Day {
  cursor: default;
}

.DayPicker-Footer {
  padding-top: 4px;
}

.DayPicker-TodayButton {
  border: none;
  background-color: transparent;
  background-image: none;
  -webkit-box-shadow: none;
          box-shadow: none;
  color: #4A90E2;
  font-size: 12px;
  cursor: pointer;
}

/* Default modifiers */

.DayPicker-Day--today {
  color: #D0021B;
  font-weight: 700;
}

.DayPicker-Day--outside {
  color: #8B9898;
  cursor: default;
  background-color: transparent;
}

.DayPicker-Day--outside.DayPicker-Day--selected {
  background-color: transparent;
}

.DayPicker-Day--disabled {
  color: #DCE0E0;
  cursor: default;
}

/* Example modifiers */


/* DayPickerInput */

.DayPickerInput {
  display: inline-block;
}

.DayPickerInput-OverlayWrapper {
  position: relative;
}

.DayPickerInput-Overlay {
  position: absolute;
  left: 0;
  z-index: 1;
  background: white;
  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/DateTimeRangePicker.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,mDAA2C;UAA3C,2CAA2C;EAC3C,yBAAyB;EACzB,gBAAiB;EAAjB,mBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,8BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,eAAe;EACf,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,mBAAY;MAAZ,oBAAY;UAAZ,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,yCAAyC;EACzC,4CAA4C;EAC5C,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;;AAGA,4BAA4B;;AAE5B;EACE,aAAa;AACf;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAAsB;UAAtB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA,qBAAqB;;AAErB;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,kBAAkB;;EAElB,8BAAmB;;EAAnB,6BAAmB;;MAAnB,uBAAmB;;UAAnB,mBAAmB;EACnB,mBAAmB;;EAEnB,yBAAyB;;IAEvB,sBAAsB;;MAEpB,qBAAqB;;UAEjB,iBAAiB;AAC3B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;;EAEV,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;EAC5B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yDAAulB;AACzlB;;AAEA;EACE,yDAAmoB;AACroB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,wBAAgB;UAAhB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB;;AAEtB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sBAAsB;;;AAGtB,mBAAmB;;AAEnB;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,iBAAiB;EACjB,iDAAyC;UAAzC,yCAAyC;AAC3C","sourcesContent":[".selectable:focus {\n  outline: none;\n}\n\n.popup {\n  font-family: Inter, 'Open Sans', sans-serif;\n  --rdp-font-family: Inter, 'Open Sans', sans-serif;\n}\n\n:global( .tether-element ) .popup {\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);\n  border: 1px solid #E0E0E0;\n  max-height: unset;\n}\n\n.rangeType > :global( .rw-widget-input ) {\n  height : 32px;\n  width : 152px;\n  box-sizing: border-box;\n}\n\n.rangeType :global( .rw-input ) {\n  color: #007AFF;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.rangeType :global( .rw-widget-input ), .rangeType :global( .rw-widget-input ):hover {\n  background-color: #F2F2F2;\n}\n\n.predeterminedTz, .dateTimeEditor, .calendar {\n  padding: 8px 16px;\n}\n\n.globe {\n  margin-right : 8px;\n  font-size: 16px;\n}\n\n.predeterminedTz {\n  border-bottom : 1px solid #E0E0E0;\n}\n\n.arrow {\n  height: 32px;\n  margin-left : 8px;\n  margin-right : 8px;\n}\n\n.timeEditor {\n  margin-left: 8px;\n}\n\n.controls {\n  background-color: #F2F2F2;\n  padding: 8px 16px;\n}\n\n.apply {\n  margin-left: 8px;\n}\n\n.inputLabel {\n  font-size: 12px;\n  color : #808080;\n}\n\n.popup .startDate, .popup .startTime, .popup .endDate, .popup .endTime {\n  background: rgba(242, 242, 242, 0.2);\n  font-size: 16px;\n}\n\n.popup .startDate, .popup .endDate {\n  width : 120px;\n  padding: 0px 8px;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  height: 32px;\n  border-radius: 3px;\n  box-sizing: border-box;\n}\n\n.popup .endTime :global( .rw-widget-picker ), .popup .startTime :global( .rw-widget-picker ) {\n  box-sizing: border-box;\n  font-size: 16px;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  height : 32px;\n  border-radius: 3px;\n  width : 140px;\n  color: var(--color-label2);\n}\n\n.popup .endTime:global(.rw-state-focus .rw-widget-container), .popup .startTime:global(.rw-state-focus .rw-widget-container) {\n  box-shadow: none;\n}\n\n.popup .startDate:focus, .popup .endDate:focus,\n.popup .endTime:global(.rw-state-focus .rw-widget-container), .popup .startTime:global(.rw-state-focus .rw-widget-container) {\n  border-color: #007AFF;\n}\n\n.popup .startTime :global( .rw-input ), .popup .endTime :global( .rw-input ) {\n  padding-right : 0px;\n}\n\n.popup .startDate.error, .popup .endDate.error {\n  border-color: var(--color-danger500);\n  background-color: #fff0f0;\n}\n\n.popup .startDate.error:hover, .popup .endDate.error:hover {\n  border-color: var(--color-danger600);\n}\n\n.dateTimeRangePicker {\n  display: flex;\n  border-radius: 4px;\n  height: 40px;\n}\n\n.dateTimeRangePicker > .startDate {\n  border-right: none;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  padding : 8px 8px 8px 16px;\n  flex-grow: 1;\n}\n\n.dateTimeRangePicker > .endDate {\n  border-left: none;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  padding : 8px 16px 8px 8px;\n  flex-grow: 1;\n}\n\n.dateTimeRangePicker > .endDate, .dateTimeRangePicker > .startDate {\n  border-color : rgba(0, 0, 0, 0.25);\n}\n\n.error input {\n  border-color: var(--color-danger500);\n  background-color: #fff0f0;\n}\n\n.error:hover input {\n  border-color: var(--color-danger600);\n}\n\n.toggleButtonTrigger { \n  height : 40px;\n}\n\n.dateTimeRangePicker > .endDate:active, .dateTimeRangePicker > .startDate:active {\n  border-color : #007AFF;\n}\n\n.dateTimeRangePicker > .arrow {\n  box-sizing: border-box;\n  border-top: 1px solid rgba(0, 0, 0, 0.25);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.25);\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n\n/* day picker custom style */\n\n.selectable > :global(.DayPicker-wrapper):focus {\n  outline: none;\n}\n\n:global( .DayPicker-Day--start.DayPicker-Day--selected ), :global( .DayPicker-Day--end.DayPicker-Day--selected ) {\n    color: white;\n    background-color: #b4ccf8;\n}\n\n:global( .DayPicker-Day--start.DayPicker-Day--selected ) {\n  border-top-left-radius: 24px;\n  border-bottom-left-radius: 24px;\n}\n\n:global( .DayPicker-Day--end.DayPicker-Day--selected ) {\n  border-top-right-radius: 24px;\n  border-bottom-right-radius: 24px;\n}\n\n:global( .DayPicker-Day--selected ) {\n  background-color: #b4ccf8;\n}\n\n:global( .DayPicker-Day:not( .DayPicker-Day--outside ):hover ) {\n  background-color: #a4bce8;\n}\n\n.circleEnd {\n  box-sizing: border-box;\n  border-radius: 24px;\n  background-color: #382CDD;\n  height: 35px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #b4ccf8;\n}\n\n:global( .DayPicker-Day:hover ) .circleEnd {\n  border-color: #a4bce8;\n}\n\n.circle {\n  background-color: transparent;\n  height: 35px;\n  width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* DayPicker styles */\n\n:global( .DayPicker ) {\n  display: inline-block;\n  font-size: 12px;\n}\n\n:global( .DayPicker-wrapper ) {\n  position: relative;\n\n  flex-direction: row;\n  padding-bottom: 8px;\n\n  -webkit-user-select: none;\n\n    -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n:global( .DayPicker-Months ) {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n:global( .DayPicker-Month ) {\n  display: table;\n  margin: 0 8px;\n  margin-top: 8px;\n  border-spacing: 0;\n  border-collapse: collapse;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin-left : 8px;\n  margin-right : 8px;\n}\n\n:global( .DayPicker-NavBar ) {\n}\n\n:global( .DayPicker-NavButton ) {\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  left: auto;\n\n  display: inline-block;\n  margin-top: 2px;\n  width: 12px;\n  height: 12px;\n  background-position: center;\n  background-size: 50%;\n  background-repeat: no-repeat;\n  color: #8B9898;\n  cursor: pointer;\n}\n\n:global( .DayPicker-NavButton:hover ) {\n  opacity: 0.8;\n}\n\n:global( .DayPicker-NavButton--prev ) {\n  margin-right: 12px;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');\n}\n\n:global( .DayPicker-NavButton--next ) {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');\n}\n\n:global( .DayPicker-NavButton--interactionDisabled ) {\n  display: none;\n}\n\n:global( .DayPicker-Caption ) {\n  display: table-caption;\n  margin-bottom: 4px;\n  padding: 0 4px;\n  text-align: left;\n}\n\n:global( .DayPicker-Caption ) > div {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n:global( .DayPicker-Weekdays ) {\n  display: table-header-group;\n  margin-top: 8px;\n}\n\n:global( .DayPicker-WeekdaysRow ) {\n  display: table-row;\n}\n\n:global( .DayPicker-Weekday ) {\n  display: table-cell;\n  padding: 4px;\n  color: #8B9898;\n  text-align: center;\n  font-size: 12px;\n}\n\n:global( .DayPicker-Weekday abbr[title] ) {\n  border-bottom: none;\n  text-decoration: none;\n}\n\n:global( .DayPicker-Body ) {\n  display: table-row-group;\n}\n\n:global( .DayPicker-Week ) {\n  display: table-row;\n}\n\n:global( .DayPicker-Day ) {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 0;\n}\n\n:global( .DayPicker-WeekNumber ) {\n  display: table-cell;\n  padding: 4px;\n  min-width: 8px;\n  border-right: 1px solid #EAECEC;\n  color: #8B9898;\n  vertical-align: middle;\n  text-align: right;\n  font-size: 10px;\n  cursor: pointer;\n}\n\n:global( .DayPicker--interactionDisabled .DayPicker-Day ) {\n  cursor: default;\n}\n\n:global( .DayPicker-Footer ) {\n  padding-top: 4px;\n}\n\n:global( .DayPicker-TodayButton ) {\n  border: none;\n  background-color: transparent;\n  background-image: none;\n  box-shadow: none;\n  color: #4A90E2;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n/* Default modifiers */\n\n:global( .DayPicker-Day--today ) {\n  color: #D0021B;\n  font-weight: 700;\n}\n\n:global( .DayPicker-Day--outside ) {\n  color: #8B9898;\n  cursor: default;\n  background-color: transparent;\n}\n\n:global( .DayPicker-Day--outside.DayPicker-Day--selected ) {\n  background-color: transparent;\n}\n\n:global( .DayPicker-Day--disabled ) {\n  color: #DCE0E0;\n  cursor: default;\n}\n\n/* Example modifiers */\n\n\n/* DayPickerInput */\n\n:global( .DayPickerInput ) {\n  display: inline-block;\n}\n\n:global( .DayPickerInput-OverlayWrapper ) {\n  position: relative;\n}\n\n:global( .DayPickerInput-Overlay ) {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n  background: white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectable": `selectable_IlVXr`,
	"popup": `popup_TmSBn`,
	"rangeType": `rangeType_sIg9E`,
	"predeterminedTz": `predeterminedTz_XCBps`,
	"dateTimeEditor": `dateTimeEditor_hffRS`,
	"calendar": `calendar_RHqpa`,
	"globe": `globe_WQgsC`,
	"arrow": `arrow_sjyrw`,
	"timeEditor": `timeEditor_WyRKI`,
	"controls": `controls_tqJVf`,
	"apply": `apply_WpbWk`,
	"inputLabel": `inputLabel_sdItN`,
	"startDate": `startDate_JA4Oo`,
	"startTime": `startTime_VIHAg`,
	"endDate": `endDate_KMunx`,
	"endTime": `endTime_CCQsI`,
	"error": `error_sRSYV`,
	"dateTimeRangePicker": `dateTimeRangePicker_QHpgm`,
	"toggleButtonTrigger": `toggleButtonTrigger_HIN0Q`,
	"circleEnd": `circleEnd_ouZc5`,
	"circle": `circle_vXxNo`
};
export default ___CSS_LOADER_EXPORT___;
